// components/ChatMessage.tsx
import React from 'react';
import { User, Bot, Sparkles } from 'lucide-react';
import type { ChatMessage as ChatMessageType } from '../types/chat.types';

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isAssistant = message.role === 'assistant';
  
  return (
    <div className={`flex gap-3 ${isAssistant ? 'flex-row' : 'flex-row-reverse'}`}>
      <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
        isAssistant 
          ? 'bg-gradient-to-br from-orange-500 to-orange-600 shadow-lg shadow-orange-500/20' 
          : 'bg-zinc-700'
      }`}>
        {isAssistant ? <Sparkles size={16} className="text-white" /> : <User size={16} className="text-gray-300" />}
      </div>
      
      <div className={`flex-1 ${isAssistant ? 'text-left' : 'text-right'}`}>
        <div className={`inline-block p-3 rounded-2xl max-w-[80%] ${
          isAssistant 
            ? 'bg-zinc-800 text-gray-200 border border-zinc-700' 
            : 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/20'
        }`}>
          <p className="text-sm whitespace-pre-wrap">{message.content}</p>
        </div>
        <p className="text-xs text-gray-500 mt-1 px-1">
          {new Date(message.timestamp).toLocaleTimeString('pl-PL', { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </p>
      </div>
    </div>
  );
};